<script setup lang="ts">
import { getVueAssetImagePath } from '@/lib/utils'
</script>

<template>
	<div class="bs-loading flex h-screen w-screen justify-center pt-[88px]">
		<div class="bs-loading__animation">
			<slot>
				<img
					class="h-[82px] w-[88px]"
					:src="getVueAssetImagePath('boxtrans.gif')"
					alt="loading icon"
				/>
			</slot>
		</div>
	</div>
</template>
